import { render, staticRenderFns } from "./CasePatientProfile.vue?vue&type=template&id=52a4b053&scoped=true&"
import script from "./CasePatientProfile.vue?vue&type=script&lang=js&"
export * from "./CasePatientProfile.vue?vue&type=script&lang=js&"
import style0 from "./CasePatientProfile.vue?vue&type=style&index=0&id=52a4b053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a4b053",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDivider,VRow,VSkeletonLoader})
